import * as React from 'react';
import {getReactButton} from "../../index";

export interface ReactAccordionData {
    id?: string,
    text?: string,
    content?: {},
    style?: {},
    css?: string,
    expandedCSS?: string,
    expandedStyle?: {},
    contentStyle?: {},
    contentCSS?: string,
    dataKey: string,
    row: any,
    rowIndex: number,
    onClick: (rowObj: any, shiftKey: boolean, ctrlKey: boolean, rowIndex: number) => boolean,
    tabIndex?: null,
    refreshID?: string,
    onRefresh?: () => {},
    title?: string,
    expandedID?: string,
    stopPropagationOnClick?: boolean,
}

export interface ReactAccordionState {
    row: any,
    content: {},
}

export class ReactAccordion extends React.Component<ReactAccordionData> {
    constructor(props: ReactAccordionData) {
        super(props);

        this.state = {
            content: props.content,
            row: props.row,
        };

        // Binding is necessary to allow these functions access to the State data
        this.hideShowAccordion = this.hideShowAccordion.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onExpandedClick = this.onExpandedClick.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactAccordionData) {
        this.setState({
            content: props.content,
            row: props.row,
        });
    }

    getAccordionIcon() {
        if((this.state as ReactAccordionState).row[this.props.dataKey])
        {
            return 'ui-accordion-header-icon ui-icon ui-icon-triangle-1-s';
        }
        else
        {
            return 'ui-accordion-header-icon ui-icon ui-icon-triangle-1-e';
        }
    }

    hideShowAccordion(event: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        const isExpanded = this.props.onClick((this.state as ReactAccordionState).row, event.shiftKey, event.ctrlKey, this.props.rowIndex);

        (this.state as ReactAccordionState).row[this.props.dataKey] = isExpanded;

        this.setState({
            row: (this.state as ReactAccordionState).row,
        });

        if(null != this.props.stopPropagationOnClick && this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            row: (this.state as ReactAccordionState).row,
        }));
    }

    onExpandedClick(event: any) {
        const isExpanded = $(event.currentTarget).is(":checked");

        (this.state as ReactAccordionState).row[this.props.dataKey] = isExpanded;

        this.setState({
            row: (this.state as ReactAccordionState).row
        });
    }

    getAccordion(isExpanded: boolean) {
        if(this.props.title) {
            return <h3
                id={this.props.id}
                tabIndex={this.props.tabIndex}
                className={(isExpanded) ? this.props.expandedCSS : this.props.css}
                onClick={this.hideShowAccordion}
                style={(isExpanded) ? this.props.expandedStyle : this.props.style}
                title={this.props.title}
            >
                <span className={this.getAccordionIcon()} ></span>
                {this.props.text}
            </h3>
        } else {
            return <h3
                id={this.props.id}
                tabIndex={this.props.tabIndex}
                className={(isExpanded) ? this.props.expandedCSS : this.props.css}
                onClick={this.hideShowAccordion}
                style={(isExpanded) ? this.props.expandedStyle : this.props.style}
            >
                <span className={this.getAccordionIcon()} ></span>
                {this.props.text}
            </h3>
        }
    }

    render() {
        const isExpanded = null != (this.state as ReactAccordionState).row[this.props.dataKey] && (this.state as ReactAccordionState).row[this.props.dataKey];

        return <div>
            {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.expandedID}
                    type="checkbox"
                    onChange={this.onExpandedClick}
                    checked={isExpanded}
                /></td>
                <td>
                    HIDDEN EXPANDED CHECKBOX
                </td>
            </tr></table>
            }
            {this.getAccordion(isExpanded)}
            <div className = {((isExpanded) ? 'fadeIn' : 'fadeOut')}>
                <div className={this.props.contentCSS} style={this.props.contentStyle}>
                    {(this.state as ReactAccordionState).content}
                </div>
            </div>
        </div>;
    }
}
